import React from "react";
import { useParams } from "react-router-dom";
import { CustomerEntry } from "../apiClient/ApiClient";
import CustomerEntryRoute from "./CustomerEntryRoute";

const ShortLinkRoute = () => {
  const { code = "" } = useParams<{ code: string }>();
  let entry: CustomerEntry | null = null;

  if (/^[A-Za-z0-9_-]{32}$/.test(code)) {
    entry = { token: code };
  } else if (/^[A-Za-z0-9_-]{7}$/.test(code)) {
    entry = { shortCode: code };
  }

  return <CustomerEntryRoute entry={entry} entryKey={code} />;
};

export default ShortLinkRoute;
